import { Localized } from "@fluent/react";
import { useLocation } from "react-router-dom";

export default function AppBarTitle(){
	const location = useLocation();

	let t;

	switch (location.pathname) {
		case '/':
			t = (
				<Localized id="app-bar-title-dashboard"></Localized>
			);
			break;

		case '/alarm-group':
			t = (
				<Localized id="app-bar-title-alarm-group"></Localized>
			);
			break;

		case '/profile':
			t = (
				<Localized id="app-bar-title-my-profile"></Localized>
			);
			break;
			
		default:
			break;
	}

	return (
		<>
		{t}
		</>
		);
}
